import { Link } from 'react-router-dom';
import { Map, CalendarCheck } from 'lucide-react';

const MobileCTA = () => (
  <div
    className="fixed inset-x-3 bottom-3 z-40 flex gap-2 rounded-2xl border border-white/40 bg-white/85 p-2 shadow-card-hover backdrop-blur-xl md:hidden"
    data-testid="mobile-sticky-cta"
  >
    <Link
      to="/career-roadmaps"
      data-testid="mobile-cta-roadmap"
      className="flex flex-1 items-center justify-center gap-2 rounded-xl border border-navy/15 py-3 text-sm font-semibold text-navy transition-colors active:bg-mist"
    >
      <Map className="h-4 w-4" /> Get Roadmap
    </Link>
    <Link
      to="/book-consultation"
      data-testid="mobile-cta-book"
      className="flex flex-1 items-center justify-center gap-2 rounded-xl bg-coral py-3 text-sm font-semibold text-white transition-colors active:bg-coral-deep"
    >
      <CalendarCheck className="h-4 w-4" /> Book Consultation
    </Link>
  </div>
);

export default MobileCTA;
